var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",attrs:{"id":"daterange","autocomplete":"off","type":"text","name":"daterange","value":""}})}
var staticRenderFns = []

export { render, staticRenderFns }